import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import vantInstall from './vant'
import '@/assets/reset.css'
import '@/assets/iconfont.css'
import '@/scss/color.scss'
import '@/page/Web/index.scss'
const app = createApp(App)
vantInstall(app)

app.use(store).use(router).mount('#app')